import { Button, Dialog, DialogActions, DialogBody, DialogContent, DialogSurface, DialogTitle } from "@fluentui/react-components";
import React from "react";

type IconProps = {
    style?: React.CSSProperties;
    color?: string;
    backgroundColor?: string;
    size?: number | string;
    textColor?: string;
    className?: string;
    opacity?: number;
    hoverColor?: string;
}
const ErrorIcon: React.FC<IconProps> = ({ color, size = 100, style, className }) => {
    return (
        <div className={className} style={{ textAlign: 'center', height: size, ...style }}>
            <svg
                width="100%"
                height="100%"
                viewBox="0 0 104 104"
                xmlns="http://www.w3.org/2000/svg"
            >
                <circle cx="32" cy="32" r="30" fill="#FCE9E9" />

                <path
                    d="M32 14C32.6406 14 33.2392 14.3204 33.5623 14.8585L48.5623 40.8585C48.8783 41.3861 48.8388 42.0473 48.4577 42.5267C48.0766 43.0061 47.4552 43.2 46.8125 43.2H17.1875C16.5448 43.2 15.9234 43.0061 15.5423 42.5267C15.1612 42.0473 15.1217 41.3861 15.4377 40.8585L30.4377 14.8585C30.7608 14.3204 31.3594 14 32 14Z"
                    fill="none"
                    stroke="#D63E3E"
                    strokeWidth="3"
                    strokeLinejoin="round"
                />

                <circle cx="32" cy="39" r="2" fill="#D63E3E" />
                <rect x="30" y="22" width="4" height="12" rx="2" ry="2" fill="#D63E3E" />

            </svg>
        </div >
    );
}
type ErrorBoundaryProps = {
    children: React.ReactNode;
};

type ErrorBoundaryState = {
    hasError: boolean;
    errorMessage: Error | undefined;
    showErrorMessage: boolean;
};

class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props)

        // Define a state variable to track whether is an error or not
        this.state = { hasError: false, errorMessage: undefined, showErrorMessage: false }
    }
    static getDerivedStateFromError(error: Error): ErrorBoundaryState {
        // Update state so the next render will show the fallback UI

        return { hasError: true, errorMessage: error, showErrorMessage: false }
    }
    componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        // You can use your own error logging service here
        console.log({ error, errorInfo })
    }

    handleClose = () => {
        this.setState({ hasError: false, errorMessage: undefined, showErrorMessage: false });
    };

    handleShowErrorMessage = () => {
        this.setState({ showErrorMessage: !this.state.showErrorMessage });
    }

    render() {
        if (this.state.hasError) {
            return (
                <>
                    <Dialog open={this.state.hasError} modalType={"alert"}>
                        <DialogSurface>
                            <div style={{ position: "absolute", top: "22px", right: "0px" }}>
                                <ErrorIcon />
                            </div>
                            <DialogBody>
                                <DialogTitle style={{ paddingTop: "6px", fontSize: "1.5rem" }}>Sorry, an error happened!</DialogTitle>
                                <DialogContent style={{ marginTop: "16px" }}>
                                    <p>Beklager, noget gik galt. Forsøg venligst igen.</p>
                                    <p style={{ paddingTop: "16px", fontStyle: "italic", opacity: "0.6", cursor: "pointer" }} onClick={this.handleShowErrorMessage}>
                                        {this.state.showErrorMessage ? "Hide error" : "see error"}
                                    </p>
                                    {
                                        this.state.hasError && this.state.showErrorMessage &&
                                        <div style={{ marginTop: "4px", padding: "8px 16px", borderRadius: "4px", backgroundColor: "#f3f2f1" }}>
                                            {this.state.errorMessage?.message}
                                        </div>
                                    }
                                </DialogContent>
                                <DialogActions>
                                    <Button appearance="primary" style={{ color: "#D63E3E", borderColor: "#D63E3E", backgroundColor: "#FCE9E9", marginTop: "16px" }} onClick={this.handleClose}>Close</Button>
                                </DialogActions>
                            </DialogBody>
                        </DialogSurface>



                    </Dialog>
                </>
            )
        }

        // Return children components in case of no error

        return this.props.children
    }
}

//<Modal isOpen={this.state.hasError} onClose={this.handleClose}>
//    <h1 style={{ paddingTop: '6px' }}>Ups, der skete en fejl!</h1>
//    <p style={{ paddingTop: '14px' }}>Beklager, noget gik galt. Forsøg venligst igen.</p>
//    <p style={{ paddingTop: '4px', fontSize: '0.6rem', fontStyle: 'italic', opacity: '0.6' }}>Fejlen er rapporteret til vores udviklere.</p>
//</Modal>

export default ErrorBoundary